<template>
  <template v-if="shownInFlow">
    <a
      :href="post.url"
      class="help-center-post-combined-title__flow-link"
    >
      <h1 class="help-center-post-combined-title__flow-title">
        {{ updatedAt }}
      </h1>
    </a>

    <h2 class="help-center-post-combined-title__flow-subtitle">
      {{ post.title }}
    </h2>
  </template>
  <template v-else>
    <h1 class="help-center-post-combined-title__title">
      {{ post.title }}
    </h1>

    <time
      v-if="updatedAt"
      class="help-center-post-combined-title__timestamp"
      :datetime="post.updated_at"
    >
      Last Updated: {{ updatedAt }}
    </time>
  </template>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  post: {
    type: Object,
    required: true
  },
  shownInFlow: Boolean
})

const updatedAt = computed(() => {
  if (props.post.updated_at) {
    const formatter = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })

    return formatter.format(new Date(props.post.updated_at))
  } else {
    return null
  }
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-post-combined-title {
  &__flow-link {
    @include help-center-highlight-link;
    display: block;
  }

  &__flow-title {
    @include help-center-font(24, title);
    font-weight: var(--help-center-bold);
  }

  &__flow-subtitle {
    @include help-center-font(24, title);
    color: var(--help-center-accent);
    font-weight: var(--help-center-bold);
    margin-top: 12px;
  }

  &__title {
    @include help-center-font(24, title);
    color: var(--help-center-accent);
    text-wrap: balance;
    font-weight: var(--help-center-bold);
  }

  &__timestamp {
    @include help-center-font(12);
    color: var(--help-center-muted);
  }
}
</style>
